module.exports = __webpack_public_path__ + "static/media/DSCF0065.b8e162ad.jpg";